import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

export const StatusIssueBadge = (status) => {
  const { authAxios } = useAuth();
  const [issue, setIssue] = useState(0);

  // Check badge on load and refresh every 5mins. 1 second = 1000
  useEffect(() => {
    fetchIssueCount();

    const intervalId = setInterval(() => {
      fetchIssueCount();
    }, 30000);

    return () => clearInterval(intervalId);
  }, []);

  const fetchIssueCount = async () => {
    let url = "";
    if (status === "Confirmed") {
      url = `/api/backoffice/shifts/count_active_confirmed_issues`;
      setIssue(0);
      return;
    }
    if (status === "Issues")
      url = `/api/backoffice/shifts/count_active_unknown`;
    if (status === "Pending")
      url = `/api/backoffice/shifts/count_active_pending`;
    if (status === "Pending Approval")
      url = `/api/backoffice/shifts/count_active_pending_approval`;
    try {
      const data = await authAxios().get(url);
      if (data.status === 200) {
        setIssue(data.data);
      } else {
        setIssue(0);
      }
    } catch (error) {
      console.log("error: ", error);
      setIssue(0);
    }
  };

  if (issue < 1) {
    return (
      <Fragment>
        <div className={"axis-tab"}>{status}</div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className={"axis-tab"}>
        {status}
        <div className={"axis-badge-number"}>{issue}</div>
      </div>
    </Fragment>
  );
};
